import { render } from "./calculation.vue?vue&type=template&id=bb49b320&ts=true"
import script from "./calculation.vue?vue&type=script&lang=ts"
export * from "./calculation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__